import React, { useState } from 'react'
import { Upload, Button, message } from 'antd'
import { UploadOutlined } from '@ant-design/icons'

const SingleFileUploader = ({ onFileSelect }) => {
  const [fileList, setFileList] = useState([])

  const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg']

  //  Handle file before upload
  const beforeUpload = (file) => {
    if (!allowedTypes.includes(file.type)) {
      message.error('Only PDF and image files (JPG, JPEG, PNG) are allowed.', 4)
      return Upload.LIST_IGNORE
    }

   
    setFileList([file])

    if (onFileSelect) {
      onFileSelect(file)
    }

    
    return false
  }

  //  Handle file removal
  const handleRemove = () => {
    setFileList([])
    if (onFileSelect) {
      onFileSelect(null)
    }
  }

  return (
    <Upload
      fileList={fileList}
      beforeUpload={beforeUpload}
      onRemove={handleRemove}
      maxCount={1}
      accept=".pdf,.jpg,.jpeg,.png"
    >
      <Button icon={<UploadOutlined />}>Select File</Button>
    </Upload>
  )
}

export default SingleFileUploader
